import Breadcrumbs from "@atoms/breadcrumbs/Breadcrumbs";
import Typography from "@atoms/typography/Typography";
import { gridStyles } from "@layout/grid";
import { cn, tw } from "@utils/tailwind";
import { FC } from "react";
import { PageHeaderProps } from "./PageHeader.types";

const rootStyles = tw`mt-[--navbar-height]
  pb-6
  pt-14
  text-content-primary-on-light
  md:pb-8
  md:pt-20
  lg:pb-7
  lg:pt-24
  xl:pb-8
  xl:pt-32`;

export const PageHeader: FC<PageHeaderProps> = ({
  title,
  breadcrumbsProps,
  underTitle,
  className,
}) => (
  <section className={cn(gridStyles.container, rootStyles, className)}>
    <Breadcrumbs
      {...breadcrumbsProps}
      className={cn(
        "mb-6 text-grey-mid md:col-span-6 md:mb-9 lg:col-span-12 xl:mb-10 2xl:col-span-10 2xl:col-start-2",
        breadcrumbsProps?.className
      )}
    />
    <Typography
      tag="h1"
      variant="h1"
      className={cn(
        gridStyles.itemShrinked,
        !!underTitle && "mb-4 md:mb-7 xl:mb-8",
        "empty:hidden"
      )}
    >
      {title}
    </Typography>
    {underTitle &&
      (typeof underTitle === "string" ? (
        <Typography tag="p" variant="lg" className={gridStyles.item}>
          {underTitle}
        </Typography>
      ) : (
        underTitle
      ))}
  </section>
);
